import { v4 as uuidv4 } from 'uuid';
import { openSnackbar } from '../store/slices/snackbar';

const getUniqueObject = (data = [], keyName = '') => {
    const newData = {};
    data.forEach((item) => {
        newData[item[keyName]] = { ...item };
    });
    return newData;
};

const getUniqueArray = (array) => array.filter((value, index, self) => self.indexOf(value) === index);

const arrayToString = (arr = []) => arr?.join(', ');

const isDuplicatedText = (arr, text, key) => {
    const isDuplicate = arr.find((item) => item[key]?.toLowerCase() === text?.toLowerCase());
    if (isDuplicate) {
        return true;
    }
    return false;
};

const getExistItems = (itemsArr = [], dataObject = {}) => {
    console.log('getExistItems', { itemsArr, dataObject });

    if (itemsArr === undefined || itemsArr?.length === 0) {
        return [];
    }

    const newData = itemsArr.filter((item) => dataObject[item] !== undefined);

    return newData;
};

const uploadFileToS3 = async (file = null, folder = '') => {
    try {
        const path = `${uuidv4()}.${file.type.split('/')[1]}`;
        const fileName = `${folder}/${path}`;
        const { key } = await Storage.put(fileName, file);
        const url = await Storage.get(key);
        return url.substring(0, url.indexOf(key)) + key;
    } catch (error) {
        console.log('ERR [uploadFileToS3] =========> ', error);
        return error;
    }
};

const deleteFileFromS3 = async (folder, uri) => {
    try {
        let path = uri?.split('/');
        path = `${folder}/${path[path?.length - 1]}`;
        const response = await Storage.remove(path);
        return response;
    } catch (error) {
        console.log('ERR [deleteFileFromS3] =========> ', error);
        return error;
    }
};

const getUniqueValueFrom2Arrays = (arr1 = [], arr2 = []) => arr2.filter((item) => arr1.includes(item) === false);

const getBtnTitle = (edit, loading) => {
    if (edit) return !loading ? 'Update' : 'Updating';
    return !loading ? 'Add' : 'Adding';
};

const onDeleteChips = (index, state, setState) => {
    console.log('state', state);

    const currItems = [...state];
    currItems.splice(index, 1);
    setState(currItems);
};

const snackBarMsg = (dispatch, message = 'All fields are required', color = 'error', open = true, close = true, variant = 'alert') => {
    const ALERT_PARAMS = {
        open,
        message,
        variant,
        alert: { color },
        close
    };

    dispatch(openSnackbar(ALERT_PARAMS));
};

const sortAlphatically = (data = [], keyName = '') =>
    data.sort((a, b) => {
        if (a[keyName] < b[keyName]) {
            return -1;
        }
        if (a[keyName] > b[keyName]) {
            return 1;
        }
        return 0;
    });

const adminSortAlphatically = (data = []) =>
    data.sort((a, b) => {
        if (a.Attributes[2].Value < b.Attributes[2].Value) {
            return -1;
        }
        if (a.Attributes[2].Value > b.Attributes[2].Value) {
            return 1;
        }
        return 0;
    });

// Cut extra text from end
const ecllipseText = (text = '', length = 0) => {
    if (text.length > length) {
        return `${text.slice(0, length)}...`;
    }
    return text;
};

export default {
    getUniqueObject,
    getUniqueArray,
    arrayToString,
    isDuplicatedText,
    getExistItems,
    getUniqueValueFrom2Arrays,
    uploadFileToS3,
    deleteFileFromS3,
    getBtnTitle,
    onDeleteChips,
    snackBarMsg,
    sortAlphatically,
    adminSortAlphatically,
    ecllipseText
};

// const a = getUniqueObject(
//     [
//         { title: 'safasfs', id: 'asfsf' },
//         { title: 'safasfs', id: 'afsfsf' }
//     ],
//     'id'
// );
// console.log('afdsaf', a);
